import React, { useState, Children } from 'react';
import { motion } from 'framer-motion';
import { JourneyTimeline } from './JourneyTimeline';
import { Mail, Smartphone, QrCode, Calendar, Globe, MessageSquare, Megaphone, Users, ExternalLink, Play } from 'lucide-react';
const container = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
const item = {
  hidden: {
    opacity: 0,
    x: -20
  },
  show: {
    opacity: 1,
    x: 0
  }
};
const channels = [{
  icon: Globe,
  label: 'Embed',
  color: '#2D2926'
}, {
  icon: Smartphone,
  label: 'SMS',
  color: '#2D2926'
}, {
  icon: MessageSquare,
  label: 'WhatsApp',
  color: '#25D366'
}, {
  icon: QrCode,
  label: 'QR Code',
  color: '#2D2926'
}, {
  icon: Megaphone,
  label: 'Social',
  color: '#2D2926'
}, {
  icon: Mail,
  label: 'Email',
  color: '#E60012'
}, {
  icon: Play,
  label: 'Ads',
  color: '#2D2926'
}, {
  icon: Users,
  label: 'Congress',
  color: '#2D2926'
}];
const channelContainer = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.04,
      delayChildren: 0.2
    }
  }
};
const channelItem = {
  hidden: {
    opacity: 0,
    scale: 0.8
  },
  show: {
    opacity: 1,
    scale: 1
  }
};
export function SlideBeforeCongress() {
  const [imgError, setImgError] = useState(false);
  return <div className="h-full w-full bg-[#FDF8F8] text-[#2D2926] p-6 md:p-10 flex flex-col" data-id="element-222">
      <JourneyTimeline currentStage={1} data-id="element-223" />

      <motion.div initial={{
      opacity: 0,
      y: 10
    }} animate={{
      opacity: 1,
      y: 0
    }} className="mb-3 border-l-4 border-[#E60012] pl-5" data-id="element-224">
        <div className="flex items-center gap-3 mb-1" data-id="element-225">
          <span className="text-2xl" data-id="element-226">🎯</span>
          <h2 className="text-xl font-bold text-[#2D2926]" data-id="element-227">Before Congress</h2>
        </div>
        <p className="text-base text-[#E60012] font-medium" data-id="element-228">
          Goal: Build anticipation and pre-qualify interest
        </p>
      </motion.div>

      <div className="flex-1 grid grid-cols-1 md:grid-cols-[1.1fr_0.9fr] gap-5 min-h-0" data-id="element-229">
        {/* Left Column — Tactics, Features, Channels */}
        <div className="flex flex-col gap-3 overflow-auto" data-id="element-230">
          <motion.div className="bg-white p-4 rounded-xl shadow-sm border border-gray-100" variants={container} initial="hidden" animate="show" data-id="element-231">
            <h3 className="text-sm font-bold text-[#2D2926] mb-3 flex items-center gap-2" data-id="element-232">
              <span className="w-6 h-1 bg-[#E60012] rounded-full" data-id="element-233"></span>
              Tactics
            </h3>
            <ul className="space-y-2.5" data-id="element-234">
              <motion.li variants={item} className="flex items-start gap-2.5" data-id="element-235">
                <Mail className="w-4 h-4 text-[#E60012] mt-0.5 shrink-0" data-id="element-236" />
                <span className="text-gray-700 text-sm" data-id="element-237">
                  Email campaigns & banners driving traffic
                </span>
              </motion.li>
              <motion.li variants={item} className="flex items-start gap-2.5" data-id="element-238">
                <Smartphone className="w-4 h-4 text-[#E60012] mt-0.5 shrink-0" data-id="element-239" />
                <span className="text-gray-700 text-sm" data-id="element-240">
                  Snaks™ embedded in landing pages and portals
                </span>
              </motion.li>
              <motion.li variants={item} className="flex items-start gap-2.5" data-id="element-241">
                <QrCode className="w-4 h-4 text-[#E60012] mt-0.5 shrink-0" data-id="element-242" />
                <span className="text-gray-700 text-sm" data-id="element-243">
                  QR codes on print & digital invites
                </span>
              </motion.li>
              <motion.li variants={item} className="flex items-start gap-2.5" data-id="element-244">
                <Calendar className="w-4 h-4 text-[#E60012] mt-0.5 shrink-0" data-id="element-245" />
                <span className="text-gray-700 text-sm" data-id="element-246">
                  Early opt-in via teaser Snak™
                </span>
              </motion.li>
            </ul>
          </motion.div>

          <motion.div className="bg-[#E60012]/5 p-4 rounded-xl border border-[#E60012]/10" variants={container} initial="hidden" animate="show" data-id="element-247">
            <h3 className="text-sm font-bold text-[#2D2926] mb-3 flex items-center gap-2" data-id="element-248">
              <span className="w-6 h-1 bg-[#FF6B6B] rounded-full" data-id="element-249"></span>
              Snakker™ Features
            </h3>
            <ul className="space-y-2.5" data-id="element-250">
              <motion.li variants={item} className="flex items-start gap-2.5" data-id="element-251">
                <div className="w-2 h-2 rounded-full bg-[#FF6B6B] mt-1.5 shrink-0" data-id="element-252" />
                <span className="text-gray-700 text-sm" data-id="element-253">
                  <strong className="text-[#2D2926]" data-id="element-254">Teaser Snaks™</strong>{' '}
                  with Menu and Poll Cues
                </span>
              </motion.li>
              <motion.li variants={item} className="flex items-start gap-2.5" data-id="element-255">
                <div className="w-2 h-2 rounded-full bg-[#FF6B6B] mt-1.5 shrink-0" data-id="element-256" />
                <span className="text-gray-700 text-sm" data-id="element-257">
                  Personalized journeys using{' '}
                  <strong className="text-[#2D2926]" data-id="element-258">Splits</strong>
                </span>
              </motion.li>
              <motion.li variants={item} className="flex items-start gap-2.5" data-id="element-259">
                <div className="w-2 h-2 rounded-full bg-[#FF6B6B] mt-1.5 shrink-0" data-id="element-260" />
                <span className="text-gray-700 text-sm" data-id="element-261">
                  Calendar links, digital contact card exchange
                </span>
              </motion.li>
            </ul>
          </motion.div>

          {/* Channel grid — compact row */}
          <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-3" data-id="element-262">
            <h3 className="text-xs font-bold text-[#2D2926] mb-2 text-center" data-id="element-263">
              Deliver Snaks™ Anywhere
            </h3>
            <motion.div className="grid grid-cols-4 gap-1.5" variants={channelContainer} initial="hidden" animate="show" data-id="element-264">
              {channels.map((ch, i) => {
              const Icon = ch.icon;
              return <motion.div key={i} variants={channelItem} className="flex flex-col items-center gap-1 bg-[#FDF8F8] rounded-lg px-1 py-1.5" data-id="element-265">
                    <div className="w-6 h-6 rounded flex items-center justify-center" style={{
                  backgroundColor: `${ch.color}15`
                }} data-id="element-266">
                      <Icon className="w-3.5 h-3.5" style={{
                    color: ch.color
                  }} data-id="element-267" />
                    </div>
                    <span className="text-[9px] font-medium text-[#2D2926]" data-id="element-268">
                      {ch.label}
                    </span>
                  </motion.div>;
            })}
            </motion.div>
          </div>
        </div>

        {/* Right Column — WhatsApp Phone Mockup (larger) */}
        <motion.div className="flex items-center justify-center min-h-0" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.3
      }} data-id="element-269">
          <div className="relative w-[260px] shrink-0" data-id="element-270">
            <div className="bg-[#1a1a1a] rounded-[28px] p-[6px] shadow-2xl" data-id="element-271">
              <div className="absolute top-[6px] left-1/2 -translate-x-1/2 w-20 h-5 bg-[#1a1a1a] rounded-b-xl z-20" data-id="element-272" />
              <div className="bg-white rounded-[22px] overflow-hidden" data-id="element-273">
                {/* WhatsApp header */}
                <div className="bg-[#2D2926] px-4 py-2.5 pt-7 flex items-center gap-2" data-id="element-274">
                  <div className="w-8 h-8 rounded-full bg-white/20 flex items-center justify-center overflow-hidden" data-id="element-275">
                    <img src="https://cdn.magicpatterns.com/uploads/1yzsnj6wqDNUHRV1oyVyfh/Screenshot_2026-03-24_at_08.34.05.png" alt="Takeda" className="h-4.5 w-auto" data-id="element-276" />
                  </div>
                  <div data-id="element-277">
                    <p className="text-white text-[10px] font-semibold" data-id="element-278">
                      Takeda
                    </p>
                    <p className="text-white/50 text-[7px]" data-id="element-279">Business account</p>
                  </div>
                </div>
                {/* Disclaimer */}
                <div className="bg-[#FDF8F8] px-3 py-1.5 flex items-center justify-center gap-1" data-id="element-280">
                  <ExternalLink className="w-2.5 h-2.5 text-[#E60012]" data-id="element-281" />
                  <span className="text-[8px] text-[#E60012] font-medium" data-id="element-282">
                    Disclaimer
                  </span>
                </div>
                {/* Chat area */}
                <div className="px-3 py-3 min-h-[240px]" style={{
                backgroundColor: '#ECE5DD'
              }} data-id="element-283">
                  <div className="flex justify-center mb-2" data-id="element-284">
                    <span className="bg-white/80 text-[7px] text-gray-500 font-medium px-2.5 py-0.5 rounded-full" data-id="element-285">
                      Today
                    </span>
                  </div>
                  <div className="bg-white rounded-lg rounded-tl-none shadow-sm p-2.5 max-w-[95%]" data-id="element-286">
                    <div className="rounded-md overflow-hidden mb-2" data-id="element-287">
                      <div className="bg-gradient-to-br from-[#2D2926] to-[#E60012] p-3 relative overflow-hidden" data-id="element-288">
                        <div className="absolute top-0 right-0 w-12 h-12 bg-[#FF6B6B]/15 rounded-bl-[24px]" data-id="element-289" />
                        <div className="flex justify-end mb-1.5" data-id="element-290">
                          <span className="text-white text-[8px] font-bold tracking-wider" data-id="element-291">
                            Takeda
                          </span>
                        </div>
                        <p className="text-white font-bold text-[9px] leading-tight mb-1 max-w-[85%]" data-id="element-292">
                          How does early intervention with vedolizumab impact
                          clinical remission rates?
                        </p>
                        <p className="text-white/70 text-[7px] leading-snug max-w-[85%]" data-id="element-293">
                          Explore the latest evidence on clinical remission
                          rates.
                        </p>
                      </div>
                      <div className="bg-[#FDF8F8] px-3 py-1.5 flex items-center gap-1.5" data-id="element-294">
                        <div className="w-4 h-4 rounded-full bg-[#2D2926] flex items-center justify-center" data-id="element-295">
                          <Play className="w-2 h-2 text-white fill-white ml-px" data-id="element-296" />
                        </div>
                        <span className="text-[8px] font-semibold text-[#2D2926]" data-id="element-297">
                          Takeda WA link
                        </span>
                      </div>
                    </div>
                    <p className="text-[9px] font-semibold text-gray-900 mb-0.5" data-id="element-298">
                      Dear Doctor,
                    </p>
                    <p className="text-[8px] text-gray-600 leading-snug mb-1.5" data-id="element-299">
                      Explore the latest remission data and safety profile
                      behind our latest treatments.
                    </p>
                    <div className="border-t border-gray-100 pt-1.5 flex items-center justify-center gap-1" data-id="element-300">
                      <Play className="w-2.5 h-2.5 text-[#E60012]" data-id="element-301" />
                      <span className="text-[9px] text-[#E60012] font-medium" data-id="element-302">
                        Learn More
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </div>;
}